export const searchKeys = [
  'SEARCH_ID_AGRICULTURE_THRESHING',
  'SEARCH_ID_AGRICULTURE_TOOL',
  'SEARCH_ID_AGRICULTURE_TRACTOR',
  'SEARCH_ID_BAP_ALL',
  'SEARCH_ID_BAP_COMMON',
  'SEARCH_ID_BAP_FREE',
  'SEARCH_ID_BAP_WANTED',
  'SEARCH_ID_BAP_WEBSTORE_SHOP',
  'SEARCH_ID_BOAT_DOCK',
  'SEARCH_ID_BOAT_DOCK_WANTED',
  'SEARCH_ID_BOAT_MOTOR',
  'SEARCH_ID_BOAT_NEW',
  'SEARCH_ID_BOAT_PARTS',
  'SEARCH_ID_BOAT_PARTS_MOTOR_WANTED',
  'SEARCH_ID_BOAT_RENT',
  'SEARCH_ID_BOAT_RENT_WANTED',
  'SEARCH_ID_BOAT_USED',
  'SEARCH_ID_BOAT_USED_WANTED',
  'SEARCH_ID_CAR_AGRI',
  'SEARCH_ID_CAR_BUS',
  'SEARCH_ID_CAR_CARAVAN',
  'SEARCH_ID_CAR_MOBILE_HOME',
  'SEARCH_ID_CAR_PARALLEL_IMPORT',
  'SEARCH_ID_CAR_TRUCK',
  'SEARCH_ID_CAR_TRUCK_ABROAD',
  'SEARCH_ID_CAR_USED',
  'SEARCH_ID_CAR_VAN',
  'SEARCH_ID_CAR_VAN_ABROAD',
  'SEARCH_ID_COMMERCIAL_PLOTS',
  'SEARCH_ID_COMMERCIAL_RENT',
  'SEARCH_ID_COMMERCIAL_SALE',
  'SEARCH_ID_COMPANY_SALE',
  'SEARCH_ID_JOB_AGGREGATED',
  'SEARCH_ID_JOB_FULLTIME',
  'SEARCH_ID_JOB_MANAGEMENT',
  'SEARCH_ID_JOB_PARTTIME',
  'SEARCH_ID_MC_ATV',
  'SEARCH_ID_MC_SCOOTER',
  'SEARCH_ID_MC_SNOWMOBILE',
  'SEARCH_ID_MC_USED',
  'SEARCH_ID_REALESTATE_ABROAD_HOMES',
  'SEARCH_ID_REALESTATE_HOMES',
  'SEARCH_ID_REALESTATE_LEISURE_PLOTS',
  'SEARCH_ID_REALESTATE_LEISURE_SALE',
  'SEARCH_ID_REALESTATE_LETTINGS',
  'SEARCH_ID_REALESTATE_LETTINGS_WANTED',
  'SEARCH_ID_REALESTATE_NEWBUILDINGS',
  'SEARCH_ID_REALESTATE_PLANNEDPROJECT',
  'SEARCH_ID_REALESTATE_PLOTS',
] as const;

export type SearchKey = (typeof searchKeys)[number];

export const verticals = [
  'B2B',
  'BAP',
  'BAP_WEBSTORE',
  'BOAT',
  'CAR',
  'JOB',
  'MC',
  'REALESTATE',
  'GLOBAL',
] as const;

export type Vertical = (typeof verticals)[number];
